export default __webpack_public_path__ + "static/home-cluster-01b496ff26d4572d2e54d76e243a58e7.svg";